import axios from "axios";
import toQueryString from "../common/utils/to-query-string";

const getPlanningAudit = (query) =>
  axios.get(toQueryString("/api/v1/admin-backfill/planning-audit?", query, true));

const recoverPlanning = (payload) =>
  axios.post("/api/v1/admin-backfill/planning-audit/recover", payload);

const planSubject = (subjectId, payload) =>
  axios.post(`/api/v1/admin-backfill/subjects/${subjectId}/plan`, payload);

const updateSubjectWeekIndex = (subjectId, payload) =>
  axios.post(`/api/v1/admin-backfill/subjects/${subjectId}/week-index`, payload);

const getSubjectPlanningRuns = (subjectId, query) =>
  axios.get(
    toQueryString(`/api/v1/admin-backfill/subjects/${subjectId}/planning-runs?`, query || {})
  );

// LF360-1842: cloned projects whose enrollment flow lost its link to the fields.
const getClonedEnrollmentReport = () =>
  axios.get("/api/v1/admin-backfill/cloned-enrollment");

const repairClonedEnrollment = (payload) =>
  axios.post("/api/v1/admin-backfill/cloned-enrollment/repair", payload);

const ApiAdminBackfill = {
  getClonedEnrollmentReport,
  repairClonedEnrollment,
  getPlanningAudit,
  recoverPlanning,
  planSubject,
  updateSubjectWeekIndex,
  getSubjectPlanningRuns,
};

export default ApiAdminBackfill;
